import { UnselectButton } from '@/components/ui/multiple-selector';
import { UserAvatar } from '@/components/ui/UserAvatar';
import { User } from '@certhon/models';

export function UserBadge({
  user,
  onUnselect,
}: {
  user: User;
  onUnselect: (() => void) | undefined;
}) {
  return (
    <div className="flex items-center gap-2">
      <UserAvatar {...user} size="sm" />
      {user.name || user.loginname || `Entity ${user.recnum}`}
      {onUnselect && <UnselectButton onUnselect={onUnselect} />}
    </div>
  );
}
